import { createRoot } from 'react-dom/client';
import { App } from './App';
import { applyTheme, getTheme } from './app/settings/theme';
import './modules';
import './styles/index.css';
import './tiles/builtin';

// No StrictMode: its double-run effects would open the single-connection OPFS database twice.
applyTheme(getTheme());
createRoot(document.getElementById('root')!).render(<App />);
